import React, { Component } from "react";
// import Spinner from "../../components/Spinners/Spinner";
import Storage from "../../services/storage.service";
// import Globals from "./../../services/globals";
// import User from "../../services/user";
// import Settings from "../../services/settings";
import Chats from "../../services/chat.service";

export default class ClosureInquiry extends Component {

  componentDidMount(){
    let inquiry = this.props.inquiry;
    if (inquiry === "CLOSED"){
      Storage.set("ticket_is_closed", true);

      // setTimeout(()=>{
      //  Chats.clearTicket();
      // }, 1000)
    }
  }

  render() {
     
    let content = "";
    let inquiry = this.props.inquiry;
    let message = this.props.message;

    if (inquiry === "WAITING") {
      content = (
        <div className="chat_notif">
          <div className="chat_notif_label">{message.message}</div>
          <div className="chat_notif_actions">
            <div
              className="action_yes"
              onClick={() => {
                Chats.confirmResolveInquiry(message, "yes");
              }}
            >
              Yes
            </div>
            <div
              className="action_no"
              onClick={() => {
                Chats.confirmResolveInquiry(message, "no");
              }}
            >
              No
            </div>
          </div>
        </div>
      );
    }

    if (
      inquiry === "CONFIRMED" ||
      inquiry === "CLOSED"
    ) {
      content = (
        <div className="chat_notif">
          <div className="chat_notif_label">{message.message}</div>
        </div>
      );
    }

    if (
      inquiry === "DECLINED"
    ){
      content = "";
    }

    let back = "";
    // if (inquiry === "CLOSED") {
    //   back = (
    //     <div
    //       className="chat_back"
    //       onClick={() => {
    //         Chats.clearTicket();
    //         Chats.retrieveTicket();
    //         // Chats.retrieveClosedTickets();
    //       }}
    //     >
    //       {" "}
    //       &lt; Back
    //     </div>
    //   );
    // }

    return (
      <div className={"closure_inquiry " + inquiry}>
        {content}
        {back}
      </div>
    );
  }
}